import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsComponent, PmsComponent } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsComponent>
    useData={usePmsComponent}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
